module.exports = __webpack_public_path__ + "img/图层 594@2x.97b295cb.png";